import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://kzklgxnbtquhjfywtnsz.supabase.co";
const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6a2xneG5idHF1aGpmeXd0bnN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwMjAyMDAsImV4cCI6MjA2MjU5NjIwMH0.L_I40DYASxgZAJkJJwyN_K3Ju05lSWl8l5X5VrgSopc";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
